import * as React from 'react';
import onClickOutside from 'react-onclickoutside';
import { AnchorLink } from 'gatsby-plugin-anchor-links';

import { HeaderQuery } from '../../../../models/strapi/stateLandingPageQuery';

import * as styles from './mobileMenu.module.scss';

interface PropType {
    mobileMenuOpen: boolean;
    toggleMobileMenu: () => void;
    data: HeaderQuery;
    usingMouse: boolean;
    setMobileMenu: (bool: boolean) => void;
}

function MobileMenu(props: PropType) {
    MobileMenu.handleClickOutside = () => props.setMobileMenu(false);

    return (
        <div
            className={styles.hider}
            style={{
                position: 'absolute'
            }}>
            {props.mobileMenuOpen ? (
                <div className={styles.menuContainer}>
                    {props.data.menuItem.map((link, i) => (
                        <div className={styles.menuItem} key={i}>
                            <div onClick={() => props.toggleMobileMenu()}>
                                <AnchorLink
                                    to={`/#${link.anchorTag}`}
                                    className={props.usingMouse ? 'using-mouse' : ''}>
                                    {link.displayText}
                                </AnchorLink>
                            </div>
                        </div>
                    ))}
                </div>
            ) : null}
        </div>
    );
}

const clickOutsideConfig = {
    handleClickOutside: () => MobileMenu.handleClickOutside
};

export default onClickOutside(MobileMenu, clickOutsideConfig);
